import {Injectable, Injector} from '@angular/core';
import {EntityCollectionServiceElementsFactory} from '@ngrx/data';
import {AbstractRepositoryV2} from 'src/app/modules/core/service/v2/abstractRepositoryV2';
import {LovValue} from '../../../api/model/LovValue.model';



@Injectable({providedIn: 'root'})
export class LovValueRepository extends AbstractRepositoryV2<LovValue>{
    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory, injector: Injector) {
        super('LovValue', serviceElementsFactory, injector);
    }
}
